import React from 'react';
import { useAtom, useAtomCallback, useAtomValue, useHydrateAtoms } from '@exodus/headless-ui';
import ErrorBoundary from '../error-boundary/error-boundary.js';
import { configAtom, fromAssetAtom, fromWalletAccountAtom, toAssetAtom, fiatModeAtom, toWalletAccountAtom, isReadyAtom, originAtom, } from '../../../atoms/index.js';
import { quoteEffect, prefillsEffect, enableTokenEffect, activeWalletAccountEffect, assetRevalidationEffect, } from '../../../effects/index.js';
export const Root = ({ config, params, children, initialFiatMode = false, }) => {
    useAtom(quoteEffect);
    useAtom(prefillsEffect);
    useAtom(enableTokenEffect);
    useAtom(activeWalletAccountEffect);
    useAtom(assetRevalidationEffect);
    useHydrateAtoms([
        [configAtom, config],
        [originAtom, params?.origin],
        [fiatModeAtom, initialFiatMode],
    ]);
    return children;
};
const SafeRoot = ({ config, fallback = null, params, children, initialFiatMode, }) => {
    const isReady = useAtomValue(isReadyAtom);
    const handleError = useAtomCallback((get, set, error, info) => {
        console.error('ExchangeUI crash', error, info);
        set(fromAssetAtom, undefined);
        set(toAssetAtom, undefined);
        set(fromWalletAccountAtom, undefined);
        set(toWalletAccountAtom, undefined);
    }, []);
    return (React.createElement(ErrorBoundary, { onError: handleError }, isReady ? (React.createElement(Root, { initialFiatMode: initialFiatMode, config: config, params: params }, children)) : (fallback)));
};
const ContextRoot = ({ config, params, children, initialFiatMode }) => (React.createElement(SafeRoot, { config: config, params: params, initialFiatMode: initialFiatMode }, children));
export default ContextRoot;
